import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ta } from '@utils';

import { TextField, Button, ResourceList, Thumbnail, DisplayText, Heading } from '@shopify/polaris';
import { QuantityProgress } from '@presentational';

import { round } from 'lodash'; 
// import ImageThumb from '@presentational/ImageThumb';

const propTypes = {
  item: PropTypes.object.isRequired,
  // currencySymbol: PropTypes.string.isRequired,
};

const defaultProps = {
}


const TransferItem = (props) => {
  const { item } = props
  // console.log("TransferItem", item);
  const unit_cost_with_tax = item.unit_cost ? round( ((Number(item.unit_cost) * 13)/100 + Number(item.unit_cost)), 2) : ""; 
  return (
    <div id={item.variant.id} className="mb10">
      <div className="row flex alignItemsCenter">

        <div className="col-sm-3 col-xl-3 flex alignItemsCenter">
          <div className="mr10">
            <Thumbnail alt={ item.variant.image_url } source={ item.variant.image_url } />
          </div>
          <div className="flex flexColumn fix-large-title">
            <p>{item.variant.display_name || item.variant.title }</p>
            <p>SKU: {item.variant.sku}</p>
            {/* { props.isAdmin && !item.bright_pearl_id && <TextStyle variation="subdued">Pendiente de sync</TextStyle> } */}
          </div>
        </div>
        

        <div className="col-sm-1">
          <QuantityProgress
            containerClass="flex1 min-height-65"
            total={ Number(item.quantity) }
            quantity={item.shipped} />
        </div>
        
        <div className="col-sm-1">
          <QuantityProgress
            containerClass="flex1 min-height-65"
            total={ Number(item.quantity) }
            quantity={item.quantity_sold}
            quantityReturned = {item.quantity_returned}
          />
        </div>
        
        <div className="col-sm-2">
          <p className="fs16">
            { item.unit_cost_money }
          </p>
        </div>
       
        <div className="col-sm-2">
          <p className="fs16">
            { item.total_amount_money }
          </p>
        </div>

        <div className="col-sm-1">
          <p className="fs16">
            { `${round(item.tax_rate)}%` }
          </p>
        </div>

        <div className="col-sm-2">
          <p className="fs16">
            { item.total_amount_with_tax_money }
          </p>
        </div>

      </div>
    </div>
  )
}

TransferItem.propTypes = propTypes;
TransferItem.defaultProps = defaultProps;


export default TransferItem;
